import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useMemo } from 'react';
const LOW_CREDIT_THRESHOLD = 10;
const parseCreditValue = value => {
  if (value === undefined || value === null) {
    return undefined;
  }
  const parsed = typeof value === 'string' ? Number(value) : value;
  return isNaN(parsed) ? undefined : parsed;
};
export const useCredit = () => {
  var _currentProductQuery$, _currentProductQuery$2;
  const currentProductQuery = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const availableCredit = (_currentProductQuery$ = currentProductQuery.data) == null || (_currentProductQuery$ = _currentProductQuery$.currentProduct) == null ? void 0 : _currentProductQuery$.availableCredit;
  const currentPlan = (_currentProductQuery$2 = currentProductQuery.data) == null || (_currentProductQuery$2 = _currentProductQuery$2.currentProduct) == null ? void 0 : _currentProductQuery$2.productName;
  const formatPrice = SwitchProductModule.SDK.useFormatPrice();
  const creditData = useMemo(() => {
    const numericValue = parseCreditValue(availableCredit == null ? void 0 : availableCredit.amount);
    const isLowCredit = (numericValue ?? 0) < LOW_CREDIT_THRESHOLD;
    const formattedValue = formatPrice(numericValue) ?? '';
    return {
      rawValue: availableCredit == null ? void 0 : availableCredit.amount,
      numericValue,
      formattedValue,
      isLowCredit,
      currentPlan
    };
  }, [availableCredit, formatPrice, currentPlan]);
  const isLoading = currentProductQuery.isLoading;
  const isError = currentProductQuery.isError;
  return {
    ...creditData,
    isLoading,
    isError
  };
};
//# sourceMappingURL=useCredit.js.map